import React from 'react';
import PropTypes from 'prop-types';

class MinisterCheckbox extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.onChange(this.props.name, e.target.checked);
  }

  render() {
    return (
      <div className={ `${this.props.name} checkbox` }>
        <input type="checkbox"
          id={ this.props.name }
          onChange={ this.handleChange }
          checked={ this.props.checked }/>
        <label htmlFor={ this.props.name }></label>
      </div>
    );
  }
}

MinisterCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  // checked: PropTypes.bool.isRequired,
};

export default MinisterCheckbox;
